// Shim Ember module
export default Ember;